import { create } from "zustand";

export const useUploadDocumentStore = create((set) => ({
  serviceLimit: 25,
  serviceOffset: 0,
  provider: null,

  setServiceLimit: (newLimit) => set({ serviceLimit: newLimit }),

  setServiceOffset: (newOffset) => set({ serviceOffset: newOffset }),

  setProvider: (newProvider) => set({ provider: newProvider }),
}));
